export const getOrInsertGlobal = <InitialValue>(
  namespace: string,
  initialValue: () => InitialValue
): InitialValue => {
  const key = `__early${namespace}Requests`;
  const global = window as any;

  if (!(key in global)) {
    global[key] = initialValue();
  }

  return global[key];
};
